import styled from '@emotion/styled';

import { Colors } from 'styles/variables/colors';

export const Title = styled.h1`
    text-transform: capitalize;
    font-weight: 700;
    font-size: 28px;
    line-height: 34px;
    margin-bottom: 40px;

    @media (max-width: 375px) {
        font-weight: 600;
        font-size: 24px;
    }
`;

export const ColumnTitle = styled.h6`
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 20px;
    color: ${Colors.darkGray};
`;

export const ColumnTitleCenter = styled.h6`
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 20px;
    color: ${Colors.darkGray};
    display: flex;
    justify-content: center;
`;

export const Text = styled.span`
    font-family: 'Assistant', sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: ${Colors.darkGray};
    line-height: 20px;
`;

export const TimerWrapper = styled.div`
    padding: 0 12px 0 6px;
`;
